import { render } from "./PageKategoriler.vue?vue&type=template&id=71b44bc4"
import script from "./PageKategoriler.vue?vue&type=script&lang=js"
export * from "./PageKategoriler.vue?vue&type=script&lang=js"
script.render = render

export default script